import { render, staticRenderFns } from "./tv-settings.vue?vue&type=template&id=c5494f8e&"
import script from "./tv-settings.vue?vue&type=script&lang=ts&"
export * from "./tv-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports